import request from '@/utils/request'

let Course_catalogApi = {

  /*课程目录列表*/
  list(data) {
    return request._post('/shop/plus.course_catalog.Index/index', data);
},
listx(data) {
    return request._post('/shop/plus.course_catalog.Index/indexx', data);
},
/*添加课程目录*/
add(data) {
    return request._post('/shop/plus.course_catalog.Index/add', data);
},
/*修改课程目录*/
edit(data) {
    return request._post('/shop/plus.course_catalog.Index/edit', data);
},
/*删除课程目录*/
del(data) {
    return request._post('/shop/plus.course_catalog.Index/del', data);
},
/*课程目录详情*/
detail(data) {
  return request._post('/shop/plus.course_catalog.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.course_catalog.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.course_catalog.Setting/getSetting', data, errorback);
    },
}
export default Course_catalogApi;



// WEBPACK FOOTER //
// ./src/api/course_catalog.js